export default __webpack_public_path__ + "static/media/Henrycoin-loading.7a9b59fc.png";